module.exports = __webpack_public_path__ + "static/4fe94f2e-7892-4785-9663-0350a7adf8c0-d09c020bda53a41bf74e47278792fcc6.woff";